import React from "react";
import { sortByOrderAscending } from "../../helper/helper";
const HopperCafeSpecials = ({ components }) => {
    const getDataIetm = (component) => {
        return (
            component?.Data?.map((val, key) => {
                return (
                    <div className="HopperCafeSpecials-card" key={key}>
                        <div className="HopperCafeSpecials-card-count">
                            <img alt="" src={val.icon} />
                        </div>
                        <div className="HopperCafeSpecials-card-cont">
                            <div className="HopperCafeSpecials-card-cont-header">{val?.header}</div>
                            <div className="HopperCafeSpecials-card-cont-subheader">{val?.subheader}</div>
                        </div>
                    </div>
                )
            })
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HopperCafeSpecials-card":
                return getDataIetm(component)

            default:
                return <div />
        }

    }
    return (
        <div className="HopperCafeSpecials">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}

        </div>
    )
}
export default HopperCafeSpecials